import { getGroupTotals } from "./balances";
import { participantName } from "./expense";
import { formatCents } from "./format";
import { APP_URL } from "./get-share-message";
import { getSettlements } from "./settlements";

const sameId = (a, b) => a != null && b != null && `${a}` === `${b}`;

const dateInBerlin = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export const formatShareDate = (date) => dateInBerlin.format(new Date(date));

export const SETTLED_TEXT = "Alles ausgeglichen – niemand schuldet etwas.";

export const describeSettlement = (settlement, participants = [], meId) => {
  const fromMe = sameId(settlement.fromId, meId);
  const toMe = sameId(settlement.toId, meId);
  const from = fromMe ? "Du" : participantName(participants, settlement.fromId);
  const to = toMe ? "dich" : participantName(participants, settlement.toId);
  const amount = formatCents(settlement.amount);
  return {
    title: `${from} → ${to}`,
    question: fromMe
      ? `Hast du ${amount} an ${to} gezahlt?`
      : `Hat ${from} ${amount} an ${to} gezahlt?`,
    involvesMe: fromMe || toMe,
  };
};

export const getSettlementShareText = (
  group,
  now = new Date(),
  origin = APP_URL,
) => {
  const participants = group?.participants ?? [];
  const name = `${group?.name ?? ""}`.trim();
  const heading = `Abrechnung${name ? ` ${name}` : ""} (${formatShareDate(now)})`;
  const transfers = getSettlements(participants).map(
    ({ fromId, toId, amount }) =>
      `${participantName(participants, fromId)} → ${participantName(
        participants,
        toId,
      )}: ${formatCents(amount)}`,
  );
  const { totalExpenses, totalIncome, incomeCount } = getGroupTotals(group);
  return [
    heading,
    ...(transfers.length ? transfers : [SETTLED_TEXT]),
    `Gesamtausgaben: ${formatCents(totalExpenses)}`,
    ...(incomeCount > 0 ? [`Einnahmen: ${formatCents(totalIncome)}`] : []),
    "",
    `Erstellt mit Split It: ${origin}`,
  ].join("\n");
};
